export type TAPICreateDeveloperRequest = {
  first_name: string;
  last_name: string;
  email: string;
  dial_country_id: string;
  phone_number: string;
  company_name?: string;
  website?: string;
  country: string;
  state?: string;
  city: string;
  postal_code?: string;
  address: string;
};

export enum DeveloperStatus {
  REGISTERED = 'REGISTERED',
  ACTIVE = 'ACTIVE',
  DEACTIVATED = 'DEACTIVATED',
}

export type TAPICreateDeveloperResponse = TAPICreateDeveloperRequest & {
  id: string;
  status: DeveloperStatus;
  status_change_date: string;
  created_at: string;
  updated_at: string | null;
};

export type TAPIDeveloperRegistrationResponse= TAPICreateDeveloperRequest & {
  registrationLink?: string;
}
